import _sortBy from 'lodash/sortBy';
import React, { Component } from 'react';
import { gql } from '@apollo/client';
import { Query } from '@apollo/react-components';
import { Breadcrumb } from 'antd';
import SpinnerError from '$components/library/SpinnerError';
import DeleteMemoryEstimate from './DeleteMemoryEstimate';
import styles from './styles.scss';

const STAFF_SYSTEM = gql`
  query StaffSystemStats {
    staffSystemStats {
      duplicateMemoryEstimates {
        uuid
        userUuid
        itemUuid
        strength
        createdAt
        updatedAt
      }
      memoryEstimatesHighestStrength
      memoryEstimatesLowestStrength
    }
  }
`;

class System extends Component {
  render() {
    return (
      <div className={styles.layout}>
        <Breadcrumb>
          <Breadcrumb.Item>System</Breadcrumb.Item>
        </Breadcrumb>
        <br />
        <Query query={STAFF_SYSTEM}>
          {({ loading, error, data }) => {
            if (loading || error) {
              return <SpinnerError error={error} />;
            }

            const { staffSystemStats } = data;
            const {
              duplicateMemoryEstimates,
              memoryEstimatesLowestStrength,
              memoryEstimatesHighestStrength,
            } = staffSystemStats;

            const sortedMemoryEstimates = _sortBy(
              duplicateMemoryEstimates,
              'userUuid',
              'itemUuid'
            );

            return (
              <div>
                <p>memoryEstimatesHighestStrength: {memoryEstimatesLowestStrength}</p>
                <p>memoryEstimatesHighestStrength: {memoryEstimatesHighestStrength}</p>
                <br />
                <div className={styles.duplicateMemoryEstimates}>
                  {sortedMemoryEstimates.map((memoryEstimate, i) => {
                    return (
                      <div
                        key={memoryEstimate.uuid}
                        className={i % 2 ? styles.even : styles.odd}
                      >
                        <DeleteMemoryEstimate memoryEstimate={memoryEstimate} />
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          }}
        </Query>
      </div>
    );
  }
}

export default System;
